import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "share",
  "use": "share-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"share\"><defs><style>#share .a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}</style></defs><path class=\"a\" d=\"M12 13.499v-13M7.5 4.999l4.5-4.5 4.5 4.5M15 8.5h4a1 1 0 011 1v13a1 1 0 01-1 1H5a1 1 0 01-1-1v-13a1 1 0 011-1h4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/share.svg
// module id = KUGl
// module chunks = 39 44